import { render, staticRenderFns } from "./common-box-mail.vue?vue&type=template&id=2637f65e&scoped=true"
import script from "./common-box-mail.vue?vue&type=script&lang=js"
export * from "./common-box-mail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2637f65e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2637f65e')) {
      api.createRecord('2637f65e', component.options)
    } else {
      api.reload('2637f65e', component.options)
    }
    module.hot.accept("./common-box-mail.vue?vue&type=template&id=2637f65e&scoped=true", function () {
      api.rerender('2637f65e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/iframe-page/components/common-box-mail.vue"
export default component.exports